module.exports = __webpack_public_path__ + "static/media/auto-centrum-matusiewicz.4085b71c.png";